module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("96imj"))).then(() => parcelRequire('1iHdE'));